// NGLA LP Scripts
if ($(".ngla-lp").length) {
  /*****************************************************************
    Lazy Load Assets
  ******************************************************************/
  var images = document.querySelectorAll("img[data-msrc]");
  var config = {
    rootMargin: "5% 5% 5% 5%",
    threshold: 0.05,
  };

  var observer;

  if ("IntersectionObserver" in window) {
    console.log("working obs");
    observer = new IntersectionObserver(onChange, config);

    // images.forEach(function (imager) {
    //   imager.classList.add("fade-in");
    // });

    images.forEach(function (img) {
      return observer.observe(img);
    });
  } else {
    // console.log("%cIntersection Observers not supported", "color: red");
    images.forEach(function (image) {
      return loadImage(image);
    });
  }

  var loadImage = function (image) {
    image.src = image.dataset.msrc;
    image.classList.add("faded");
  };

  function onChange(changes, observer) {
    changes.forEach(function (change) {
      if (change.intersectionRatio > 0) {
        // Stop watching and load the image
        console.log(change.intersectionRatio);
        loadImage(change.target);
        observer.unobserve(change.target);
      }
    });
  }
}
